import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export const NumberFormatCustom = ({ inputRef, onChange, id, name, format, value, ...props }) => {
  return (
    <NumberFormat
      {...format}
      {...props}
      id={id}
      value={value || value === 0 ? value : ''}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.floatValue,
            id,
            name
          }
        });
      }}
    />
  );
};
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  format: PropTypes.shape({
    thousandSeparator: PropTypes.bool,
    decimalSeparator: PropTypes.bool,
    allowNegative: PropTypes.bool,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    mask: PropTypes.string
  })
};

NumberFormatCustom.defaultProps = {
  format: {},
  value: undefined
};
